import { FC, useEffect, useState } from 'react';
import animateScrollTo from 'animated-scroll-to';
import s from './scrollUpArrow.module.scss';
import cn from 'classnames';
import { Button } from '../Button/Button';
import { SpriteIcon } from '@components/Sprites/SpriteIcon';
interface ScrollUpArrowProps {}
export const ScrollUpArrow: FC<ScrollUpArrowProps> = ({}) => {
  const [disabled, setDisabled] = useState(false);
  const [hide, setHide] = useState(true);
  const clickHandler = async () => {
    if (disabled) return;
    setDisabled(true);
    await animateScrollTo(0);
    setDisabled(false);
  };
  useEffect(() => {
    const handleScroll = () => {
      setHide(!(window.scrollY > 0));
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return <div className={cn(s.scrollUpArrow, disabled && s.scrollUpArrow_disabled, hide && s.scrollUpArrow_hide)} onClick={clickHandler} data-sentry-component="ScrollUpArrow" data-sentry-source-file="ScrollUpArrow.tsx">
            <Button id='default_button' color='Black' size='large' data-sentry-element="Button" data-sentry-source-file="ScrollUpArrow.tsx">
                <SpriteIcon name='arrow_up' width={14} height={14} data-sentry-element="SpriteIcon" data-sentry-source-file="ScrollUpArrow.tsx" />
            </Button>
        </div>;
};